export default {
    groupName: 'Tmobile-Business',
    appName: 'T-Mobile for Business',
    baseRoute: '/dashboard/TMobile-Business',
    label: 'Ad Effect Dashboard',
    home: '/slicer',
    image: 'T-Mobile_for_Business.png',
    description: 'T-Mobile for Business Ad Effect Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/config/main.js